import ReactGA from 'react-ga';

export const logPageView = (history: any) => {
  ReactGA.pageview(window.location.pathname + window.location.search);

  history.listen((location: any) => {
    const page = location.pathname || window.location.pathname;
    const search = location.search || window.location.search;
    ReactGA.set({ page: page });
    ReactGA.pageview(page + search);
  });
};
